import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AnalyticsProvider } from "@/libs/analytics";
import { createAnalyticsConfig } from "@/libs/analytics/config";

export const Route = createFileRoute("/(meet)")({
  component: MeetLayout,
});

function MeetLayout() {
  return (
    <AnalyticsProvider
      config={createAnalyticsConfig({ allowedProviders: ["mixpanel"] })}
    >
      <Outlet />
    </AnalyticsProvider>
  );
}
